module.exports = __webpack_public_path__ + "resource/img/calendar.531bd3ac.svg";